import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { uploadService } from '../services/upload-service'
import { useNotification } from './useNotification'

/**
 * Hook for uploading files to S3 via data connectors.
 * Upload continues even if component unmounts.
 * Automatically triggers status polling after successful upload.
 *
 * @returns Object containing:
 *   - uploadFile: Function to trigger upload (fire-and-forget)
 */
export function useUploadFileService() {
  const { notify } = useNotification()
  const { t } = useTranslation()

  /**
   * Uploads a file through the complete upload flow: get URL, upload to S3, mark complete.
   * Fire-and-forget - continues even if component unmounts.
   * Automatically triggers status polling after successful upload.
   *
   * @param file - The file to upload
   */
  const uploadFile = useCallback(
    (file: File): void => {
      uploadService.uploadFile(file, notify, t)
    },
    [notify, t]
  )

  return { uploadFile }
}
